<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container">
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="managers-list" v-if="isLoad">
            <div class="page-title">
              <h2>Managers</h2>
            </div>
            <div class="managers-list__inner">
              <div class="managers-list__col" v-for="user in managers" :key="user.id">
                <div class="managers-list__item">
                  <div class="managers-list__item__box">
                    <div class="managers-list__item__image h-object-fit">
                      <img v-if="user.photo" :src="`${API}/documents/share/images/${user.photo}?size=SMALL`" alt="image"/>
                      <span v-if="!user.photo"></span>
                    </div>
                    <div class="managers-list__item__name-wrapper">
                      <span class="managers-list__item__name">{{ user.firstName }}</span>
                      <span class="managers-list__item__name-mfa">
                        <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.0013 6.62689H10.3567H10.3566V4.35658C10.3565 1.95439 8.4022 0 5.99995 0C3.59784 0 1.64344 1.95439 1.64344 4.35661V6.62692H0.998749C0.489113 6.62692 0.0758972 7.04007 0.0758972 7.54974V8.11113V14.5158V15.0772C0.0758972 15.5869 0.489081 16 0.998749 16H5.99999H11.0013C11.5109 16 11.9241 15.5869 11.9241 15.0772V14.5158V8.11113V7.54974C11.9241 7.04004 11.5109 6.62689 11.0013 6.62689ZM6.98225 13.2372H5.01776L5.36935 11.5619C5.04055 11.3526 4.82092 10.9873 4.82092 10.5687C4.82092 9.91751 5.34885 9.38965 5.99999 9.38965C6.65116 9.38965 7.17899 9.91751 7.17899 10.5687C7.17899 10.9873 6.95943 11.3526 6.63065 11.5618L6.98225 13.2372ZM8.80207 6.62689H5.99999H3.19807H3.1979V4.35658C3.1979 2.81136 4.45484 1.55446 5.99999 1.55446C7.5452 1.55446 8.80207 2.81139 8.80207 4.35658V6.62689Z" fill="#5B5B5B"/>
                        </svg>
                        <span v-if="user.mfaEnabled" class="managers-list__item__name-mfa--enabled">
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="14" height="14" rx="7" fill="#77B017"/>
                            <path d="M6.23732 9.77084C6.16395 9.84212 6.06384 9.88189 5.95986 9.88189C5.85588 9.88189 5.75578 9.84212 5.68241 9.77084L3.46656 7.63023C3.23661 7.40812 3.23661 7.04795 3.46656 6.82626L3.74402 6.5582C3.97405 6.33609 4.34651 6.33609 4.57646 6.5582L5.95986 7.89448L9.69801 4.28377C9.92804 4.06166 10.3009 4.06166 10.5304 4.28377L10.8079 4.55183C11.0379 4.77394 11.0379 5.13404 10.8079 5.35581L6.23732 9.77084Z" fill="white"/>
                          </svg>
                        </span>
                        <span v-else class="managers-list__item__name-mfa--enabled">
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.9522 2.04807C9.22088 -0.682691 4.77896 -0.682691 2.04762 2.04807C-0.68254 4.77884 -0.68254 9.22191 2.04762 11.9527C3.41329 13.3178 5.20674 14 7.00022 14C8.7937 14 10.5866 13.3177 11.9522 11.9527C14.683 9.22194 14.683 4.77884 11.9522 2.04807ZM9.88854 9.06376C10.1167 9.29194 10.1167 9.6608 9.88854 9.88899C9.77473 10.0028 9.62533 10.06 9.47591 10.06C9.32651 10.06 9.17709 10.0028 9.06328 9.88899L7.00019 7.8253L4.93768 9.88838C4.8233 10.0022 4.67388 10.0594 4.52506 10.0594C4.37566 10.0594 4.22623 10.0022 4.11243 9.88838C3.88424 9.6602 3.88424 9.29077 4.11243 9.06316L6.17494 7.00007L4.11185 4.93699C3.88367 4.7088 3.88367 4.33937 4.11185 4.11176C4.33947 3.88357 4.7089 3.88357 4.93708 4.11176L7.00017 6.17484L9.06325 4.11176C9.29144 3.88357 9.6603 3.88357 9.88848 4.11176C10.1167 4.33937 10.1167 4.7088 9.88848 4.93699L7.8254 7.00007L9.88854 9.06376Z" fill="#E82020"/>
                          </svg>
                        </span>
                      </span>
                    </div>
                  </div>
                  <button type="button" class="btn btn--edit" @click="editUser(user)">
                    <svg width="1em" height="1em" class="icon icon-edit ">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn--green btn--add-manager" @click="addUser"><span>Add Manager</span>
            </button>
          </section>
          <section class="managers-add" v-if="visibleInputs">
            <div class="page-title">
              <h2>{{ titleSection }}</h2>
            </div>
            <form action="javascript:void(0)" class="managers-add-form">
              <div class="managers-add-form__fields">
                <div class="managers-add-form__col">
                  <div class="form-control-group"><span class="form-control-label">Role:</span>
                    <div
                        :class="['form-control-wrap select-wrapper', { 'is-active' : selects.role }, { 'is-error' : error.role }]">
                      <div class="select-trigger" @click="changeSelects('role');error.role = false"><span
                          class="select-trigger__name">{{
                          (inputs.roles.admin ? 'Admin' : '') + (inputs.roles.admin && (inputs.roles.content || inputs.roles.sales || inputs.roles.accountant) ? ', ' : '') + (inputs.roles.content ? 'Content Manager' : '') + (inputs.roles.content && inputs.roles.sales ? ', ' : '') + (inputs.roles.sales ? 'Sales Manager' : '') + (inputs.roles.accountant ? 'Accountant' : '')
                        }}</span><span class="select-trigger__icon">
                                    <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                    </svg></span></div>
                      <div class="select-body">
                        <div class="select-inner">
                          <div :class="['select-option', { 'is-selected' : inputs.roles.admin }]"
                               @click="inputs = { ...inputs, roles: {... inputs.roles, admin: !inputs.roles.admin} };isEditFlag = true">
                            <label for="select_opt_1" class="form-control-checkbox" @click.prevent>
                              <input id="select_opt_1" type="checkbox" :checked="inputs.roles.admin"/><span
                                class="form-control-checkbox__box">
                                        <svg width="1em" height="1em" class="icon icon-check ">
                                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                        </svg></span><span class="select-option__name">Admin</span>
                            </label>
                          </div>
                          <div :class="['select-option', { 'is-selected' : inputs.roles.content }]"
                               @click="inputs = { ...inputs, roles: {... inputs.roles, content: !inputs.roles.content} };isEditFlag = true">
                            <label for="select_opt_2" class="form-control-checkbox" @click.prevent>
                              <input id="select_opt_2" type="checkbox" :checked="inputs.roles.content"/><span
                                class="form-control-checkbox__box">
                                        <svg width="1em" height="1em" class="icon icon-check ">
                                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                        </svg></span><span class="select-option__name">Content Manager</span>
                            </label>
                          </div>
                          <div :class="['select-option', { 'is-selected' : inputs.roles.sales }]"
                               @click="inputs = { ...inputs, roles: {... inputs.roles, sales: !inputs.roles.sales} };isEditFlag = true">
                            <label for="select_opt_3" class="form-control-checkbox" @click.prevent>
                              <input id="select_opt_3" type="checkbox" :checked="inputs.roles.sales"/><span
                                class="form-control-checkbox__box">
                                        <svg width="1em" height="1em" class="icon icon-check ">
                                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                        </svg></span><span class="select-option__name">Sales Manager</span>
                            </label>
                          </div>
                          <div :class="['select-option', { 'is-selected' : inputs.roles.accountant }]"
                               @click="inputs = { ...inputs, roles: {... inputs.roles, accountant: !inputs.roles.accountant} };isEditFlag = true">
                            <label for="select_opt_3" class="form-control-checkbox" @click.prevent>
                              <input id="select_opt_3" type="checkbox" :checked="inputs.roles.accountant"/><span
                                class="form-control-checkbox__box">
                                        <svg width="1em" height="1em" class="icon icon-check ">
                                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                        </svg></span><span class="select-option__name">Accountant</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span class="form-control-error-descr">Choose roles</span>
                  </div>
                </div>
                <div class="managers-add-form__col">
                  <div class="form-control-group"><span class="form-control-label">Email:</span>
                    <div :class="['form-control-wrap', { 'is-error' : error.email }]">
                      <input type="text" Placeholder="Email" v-model="inputs.email"
                             @input="inputs.email = $event.target.value.replace(/[А-Яа-я]/g, '');isEditFlag = true"
                             @focus="error.email = false" class="form-control"/>
                    </div>
                    <span class="form-control-error-descr">Incorrect email</span>
                  </div>
                </div>
                <div class="managers-add-form__col managers-add-form__col--sm">
                  <div class="form-control-group"><span class="form-control-label">Login:</span>
                    <div :class="['form-control-wrap', { 'is-error' : error.login }]">
                      <input type="text" Placeholder="Login" v-model="inputs.login"
                             @input="inputs.login = $event.target.value.replace(/[А-Яа-я]/g, '');isEditFlag = true"
                             @focus="error.login = false" class="form-control"/>
                    </div>
                    <span class="form-control-error-descr">Incorrect login</span>
                  </div>
                </div>
                <div class="managers-add-form__col managers-add-form__col--lg">
                  <div class="form-control-group"><span class="form-control-label">Password:</span>
                    <div :class="['form-control-wrap form-control-wrap--double', { 'is-error' : error.password }]">
                      <input type="text" Placeholder="Password" v-model="inputs.password" @input=";isEditFlag = true"
                             @focus="error.password = false" class="form-control"/>
                      <button type="button" class="btn btn--generate-pass" @click="genPass">
                        <svg width="1em" height="1em" class="icon icon-generate ">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-generate"></use>
                        </svg>
                        <span>Generate</span>
                      </button>
                    </div>
                    <span class="form-control-error-descr">Incorrect password</span>
                  </div>
                </div>
                <div class="form-control-group" :style="{marginRight: '10px'}"><span
                    class="form-control-label">Language</span>
                  <div :class="['select-wrapper select-wrapper__lang', {'is-active' : selects.lang} ]"
                       @click="changeSelects('lang')">
                    <div class="select-trigger">
                      <div class="select-trigger__flag__icon">
                        <svg width="1em" height="1em" class="icon icon-gb" :style="{width: '18px', height: '18px'}">
                          <use
                              :xlink:href="'/images/useful/svg/theme/symbol-defs.svg#icon-' + dataSelects.lang.find(item => item.active).icon"></use>
                        </svg>
                      </div>
                      <span
                          class="select-trigger__name">{{ dataSelects.lang.find(item => item.active).name }}</span><span
                        class="select-trigger__icon">
									<svg width="1em" height="1em" class="icon icon-chevron ">
									<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
									</svg></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner js-scrollbar">
                        <div
                            v-for="item in dataSelects.lang"
                            :key="item.name"
                            :class="['select-option', { 'is-selected' : item.active }]"
                            @click="dataSelects.lang = dataSelects.lang.map(i => i.name === item.name ? ({...i, active: true}) : ({...i, active: false}));isEditFlag = true">
										<span class="select-option__name"><div class="select-trigger__flag__icon">
											<svg width="1em" height="1em" class="icon icon-gb "
                           :style="{width: '18px', height: '18px', marginBottom: '1px'}">
												<use :xlink:href="'/images/useful/svg/theme/symbol-defs.svg#icon-' + item.icon"></use>
											</svg>
											</div>{{ item.name }}
										</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="managers-add-form__col">
                  <div class="form-control-group"><span class="form-control-label">Name:</span>
                    <div :class="['form-control-wrap', { 'is-error' : error.name }]">
                      <input type="text" Placeholder="Name" v-model="inputs.name"
                             @input="inputs.name = $event.target.value.replace(/[0-9]/g, '');isEditFlag = true"
                             @focus="error.name = false" class="form-control"/>
                    </div>
                    <span class="form-control-error-descr">Incorrect name</span>
                  </div>
                </div>
                <div class="managers-add-form__col">
                  <div class="form-control-group"><span class="form-control-label">Surname:</span>
                    <div :class="['form-control-wrap', { 'is-error' : error.surname }]">
                      <input type="text" Placeholder="Surname" v-model="inputs.surname"
                             @input="inputs.surname = $event.target.value.replace(/[0-9]/g, '');isEditFlag = true"
                             @focus="error.surname = false" class="form-control"/>
                    </div>
                    <span class="form-control-error-descr">Incorrect surname</span>
                  </div>
                </div>
                <div class="managers-add-form__col">
                  <div class="form-control-group"><span class="form-control-label">Mobile number:</span>
                    <div class="form-control-wrap">
                      <input type="text" Placeholder="phone" v-model="inputs.number" @input.once="isEditFlag = true" class="form-control"/>
                    </div>
                  </div>
                </div>
                <!--                        <div class="managers-add-form__col managers-add-form__col&#45;&#45;xl">-->
                <!--                            <div class="form-control-group form-control-group&#45;&#45;cell">-->
                <!--                            <div class="form-control-group__side"><span class="form-control-label">Country:</span>-->
                <!--                                <div :class="['select-wrapper', 'select-wrapper&#45;&#45;xs', { 'is-active' : selects.country }]" @click="changeSelects('country')">-->
                <!--                                <div class="select-trigger"><span class="select-trigger__name">-->

                <!--                                    <div class="select-trigger__flag__icon" :style="{marginLeft: '0px', display: 'flex', marginRight: '5px'}">-->
                <!--                                        <span :class="['flag-icon flag-icon-squared', 'flag-icon-' + inputs.country.data.toLowerCase() ]" :style="{-->
                <!--                                            fontSize: '18px',-->
                <!--                                            borderRadius: '50%',-->
                <!--                                            marginLeft: '0px',-->
                <!--                                            marginTop: '0px'-->
                <!--                                        }"></span>-->
                <!--                                    </div> <span>{{inputs.country.code.replace('R', '').replace('K', '')}}</span>-->
                <!--                                    </span><span class="select-trigger__icon">-->
                <!--                                    <svg width="1em" height="1em" class="icon icon-chevron ">-->
                <!--                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>-->
                <!--                                    </svg></span></div>-->
                <!--                                <div class="select-body">-->
                <!--                                    <div class="select-inner js-scrollbar">-->
                <!--                                    <div-->
                <!--									v-for="city in dataSelects.countries"-->
                <!--									:key="city.data"-->
                <!--									:class="['select-option', { 'is-selected' : city.data === inputs.country.data }]" @click="inputs.country = city">-->
                <!--									<span class="select-option__name">-->
                <!--										<div class="select-trigger__flag__icon" :style="{marginLeft: '0px', display: 'flex', marginRight: '5px'}">-->
                <!--											<span :class="['flag-icon flag-icon-squared', 'flag-icon-' + city.data.toLowerCase() ]" :style="{-->
                <!--												 fontSize: '18px',-->
                <!--												 borderRadius: '50%',-->
                <!--												 marginLeft: '0px',-->
                <!--												 marginTop: '0px'-->
                <!--											}"></span>-->
                <!--										</div>{{city.code.replace('R', '').replace('K', '')}}-->
                <!--									</span>-->
                <!--									</div>-->
                <!--                                    </div>-->
                <!--                                </div>-->
                <!--                                </div>-->
                <!--                            </div>-->
                <!--                            <div class="form-control-group__side"><span class="form-control-label">Mobile number:</span>-->
                <!--                                <div :class="['form-control-wrap', { 'is-error' : error.number }]">-->
                <!--                                <input type="number" Placeholder="Number" v-model="inputs.number" @input="inputs.number = $event.target.value.replace(/\D/g, '');isEditFlag = true" @focus="error.number = false" class="form-control"/>-->
                <!--                                </div>-->
                <!--                                <span class="form-control-error-descr">Incorrect number</span>-->
                <!--                            </div>-->
                <!--                            </div>-->
                <!--                        </div>-->
              </div>
              <div class="managers-add-form__socials">
                <div class="form-control-group"
                     @click="inputs = { ...inputs, telegram: { ...inputs.telegram, active: !inputs.telegram.active } };isEditFlag = true">
                  <label for="chk_telegram" class="form-control-checkbox" @click.prevent>
                    <input id="chk_telegram" type="checkbox" :checked="inputs.telegram.active"/><span
                      class="form-control-checkbox__box">
                                <svg width="1em" height="1em" class="icon icon-check ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                </svg></span><span class="form-control-checkbox__name">Telegram</span><img
                      src="/images/useful/svg/telegram.svg" alt="telegram" class="form-control-checkbox__img"/>
                  </label>
                </div>
                <div class="form-control-group"
                     @click="inputs = { ...inputs, whatsapp: { ...inputs.whatsapp, active: !inputs.whatsapp.active } };isEditFlag = true">
                  <label for="chk_wahtsapp" class="form-control-checkbox" @click.prevent>
                    <input id="chk_wahtsapp" type="checkbox" :checked="inputs.whatsapp.active"/><span
                      class="form-control-checkbox__box">
                                <svg width="1em" height="1em" class="icon icon-check ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                </svg></span><span class="form-control-checkbox__name">WhatsApp</span><img
                      src="/images/useful/svg/whatsapp.svg" alt="whatsapp" class="form-control-checkbox__img"/>
                  </label>
                </div>
              </div>
              <div class="form-control-group" :style="{display: 'flex', alignItems: 'flex-start'}">
                <div class="managers-add-form__social-field" v-if="inputs.telegram.active">
                  <div class="form-control-group"><span class="form-control-label">Telegram login</span>
                    <div :class="['form-control-wrap', { 'is-error' : error.telegram }]">
                      <input type="text" placeholder="@login" v-model="inputs.telegram.login" @input="isEditFlag = true"
                             @focus="error.telegram = false" class="form-control"/>
                    </div>
                    <span class="form-control-error-descr">Incorrect telegram</span>
                  </div>
                </div>
                <div class="managers-add-form__social-field" v-if="inputs.telegram.active">
                  <div class="form-control-group"><span class="form-control-label">Telegram ID</span>
                    <div :class="['form-control-wrap', { 'is-error' : error.telegramID }]">
                      <input type="text" placeholder="" v-model="inputs.telegram.ID" @input="isEditFlag = true"
                             @focus="error.telegramID = false" class="form-control"/>
                    </div>
                    <span class="form-control-error-descr">Incorrect telegram ID</span>
                  </div>
                </div>
              </div>

              <div class="managers-edit-mfa__container" v-if="isEdit">
                <div class="managers-edit-mfa__label">Two-Factor Authentication:</div>
                <div class="switch">
                  <label class="switch-label"><input type="checkbox" v-model="inputs.mfaEnabled" @change="configureMfa()"/>
                    <span class="switch-inp"></span>
                  </label>
                </div>
                <div class="managers-edit-mfa__status">{{inputs.mfaEnabled === true ? 'Enabled' : 'Disabled'}}</div>
              </div>

              <div class="managers-add-form__load-photo" :style="{display: 'flex'}">
                <div class="form-control-photo-group" @click="isSign = false">
                  <input type="file" id="photo_load1" class="input-hidden" @change="isEditFlag = true;isSign = false"/>
                  <label class="form-control-photo" v-if="!uploaded" @click="$emit('changeImage', 'circle')">
                    <span class="form-control-photo__box h-object-fit"></span>
                  </label>
                  <div class="form-control-photo" v-if="uploaded"><span class="form-control-photo__box h-object-fit">
                                <img :src="`${API}/documents/share/images/${inputs.photo}?size=MEDIUM`"
                                     alt="photo"></span>
                    <button type="button" class="btn btn--remove" @click="removeAvatar">
                      <svg width="1em" height="1em" class="icon icon-close ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                      </svg>
                    </button>
                  </div>
                  <div class="form-control-photo-content">
                    <div class="form-control-photo-content__line">
                      <span class="form-control-photo-name">Photo</span>
                    </div>
                    <div class="form-control-photo-content__line">
                      <label @click="$emit('changeImage', 'circle')"
                             class="btn btn--rounded btn-photo-load">{{ uploaded ? 'Change photo' : 'Add Photo' }}</label>
                    </div>
                  </div>
                </div>
                <div class="form-control-photo-group" @click="isSign = true">
                  <input type="file" id="photo_load11" class="input-hidden" @change="isEditFlag = true;isSign = true"/>
                  <label class="form-control-photo" v-if="!uploadedSign" @click="$emit('changeImage', 'circle')">
                    <span class="form-control-photo__box h-object-fit"></span>
                  </label>
                  <div class="form-control-photo" v-if="uploadedSign"><span
                      class="form-control-photo__box h-object-fit">
                                <img :src="`${API}/documents/share/images/${inputs.signPhoto}?size=MEDIUM`" alt="photo"></span>
                    <button type="button" class="btn btn--remove" @click="removeAvatarSign">
                      <svg width="1em" height="1em" class="icon icon-close ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                      </svg>
                    </button>
                  </div>
                  <div class="form-control-photo-content">
                    <div class="form-control-photo-content__line">
                      <span class="form-control-photo-name">Sign photo</span>
                    </div>
                    <div class="form-control-photo-content__line">
                      <label @click="$emit('changeImage', 'circle-spec')"
                             class="btn btn--rounded btn-photo-load">{{ uploadedSign ? 'Change photo' : 'Add Photo' }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="managers-add-form__footer">
                <button type="button" class="btn btn--silver" @click="isEdit ? $emit('deleteModalHandler', {
                                entity: 'Manager',
                                name: 'this',
                                handler: deleteUserHandler,
                                id: null
                            }) : cancelInputs()"><span>{{ cancelBtn }}</span></button>
                <button type="button" class="btn btn--green"
                        @click="isEdit ? updateUserHandler() : createUserHandler()">
                  <span>{{ titleSection === 'Add Manager' ? 'Add Manager' : 'Save Changes' }}</span></button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </main>
    <div class="modal-wrapper" v-if="mfa.popup">
      <div class="modal-backdrop" ></div>
      <div class="modal-inner" @click="mfa.popup = false">
        <div class="edit-popup managers-edit-mfa--poput" @click.stop>
          <div class="edit-popup__header">
            <div class="edit-popup__title">
            </div>
            <div class="edit-popup__close" @click="mfa.popup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="managers-edit-mfa__title">
            QR Code for Authorization
          </div>
          <div class="managers-edit-mfa__code">
            <img class="managers-edit-mfa__code-image" :src="mfa.qrCodeSrc" alt="QR">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import generator from 'generate-password'

import {
  getUsers,
  updateUser,
  createUser,
  getUser,
  uploadUserImage,
  deleteUser,
  API,
  postConfigureMfa
} from '@/utilites/api'

import {
  validateEmail
} from '@/utilites/functions'

import countries from '@/utilites/countries'

export default {
  beforeCreate() {
    document.title = 'Managers'
  },
  props: ['user', 'uploadedFile'],
  data() {
    return {
      managers: [],
      titleSection: 'Add Manager',
      visibleInputs: false,
      isEdit: false,
      isEditFlag: false,
      API: API,
      toDelete: null,
      isLoad: false,
      isSign: false,
      inputs: {
        roles: {
          admin: false,
          content: false,
          sales: false,
          accountant: false
        },
        email: '',
        login: '',
        password: '',
        name: '',
        surname: '',
        country: {
          code: '(+1)',
          data: 'ru'
        },
        number: '',
        telegram: {
          active: false,
          login: '',
          ID: ''
        },
        whatsapp: {
          active: false
        },
        mfaEnabled: false,
        photo: null,
        signPhoto: null
      },
      uploaded: false,
      uploadedSign: false,
      cancelBtn: 'Delete Manager',
      selects: {
        role: false,
        country: false,
        lang: false
      },
      dataSelects: {
        lang: [
          {
            name: 'English',
            data: 'EN',
            icon: 'gb',
            active: true,
          },
          {
            name: 'Russian',
            icon: 'rus',
            data: 'RU',
            active: false,
          },
          {
            name: 'Deutch',
            icon: 'deu',
            data: 'DE',
            active: false,
          }
        ],
        countries: []
      },
      error: {
        role: false,
        email: false,
        login: false,
        password: false,
        name: false,
        surname: false,
        number: false,
        telegram: false,
        telegramID: false
      },
      mfa: {
        popup: false,
        qrCodeSrc: null,
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEditFlag) {
      this.$emit('notLeaveHandler')
    }
    next()
  },
  methods: {
    changeSelects(target) {
      this.selects = {
        role: false,
        country: false,
        lang: false,
        [target]: !this.selects[target]
      }
    },
    checkError() {
      this.error = {
        role: !this.inputs.roles.admin && !this.inputs.roles.content && !this.inputs.roles.sales && !this.inputs.roles.accountant,
        email: !validateEmail(this.inputs.email.trim()) || this.inputs.email.trim().length === 0,
        login: /[^A-Za-z0-9\-]/g.test(this.inputs.login.trim()) || this.inputs.login.trim().length === 0,
        password: !this.isEdit ? this.inputs.password.trim().length === 0 : false,
        name: /[^A-Za-zА-Яа-я\- ]/g.test(this.inputs.name.trim()) || this.inputs.name.trim().length === 0,
        surname: /[^A-Za-zА-Яа-я\- ]/g.test(this.inputs.surname.trim()) || this.inputs.surname.trim().length === 0,
        telegram: this.inputs.telegram.active ? /[^A-Za-z0-9\-\@\_]/g.test(this.inputs.telegram.login.trim()) || this.inputs.telegram.login.trim().length === 0 : false,
        telegramID: this.inputs.telegram.active ? /[^0-9]/g.test(this.inputs.telegram.ID.trim()) || this.inputs.telegram.ID.trim().length === 0 : false,
      }
      let error = false
      for (const key in this.error) {
        if (this.error[key]) {
          error = true
        }
      }
      return error
    },
    addUser() {
      this.titleSection = 'Add Manager'
      this.cancelBtn = 'Cancel',
          this.visibleInputs = true
      this.isEdit = false
      //set inputs
      this.inputs = {
        roles: {
          admin: false,
          content: false,
          sales: false,
          accountant: false
        },
        email: '',
        login: '',
        password: '',
        name: '',
        surname: '',
        country: {
          code: '(+7)',
          data: 'ru'
        },
        number: '',
        telegram: {
          active: false,
          login: ''
        },
        whatsapp: {
          active: false
        },
        photo: null,
        signPhoto: null
      }
      this.uploaded = false
      this.uploadedSign = false
    },
    cancelInputs() {
      this.visibleInputs = false
      this.isEditFlag = false
    },
    editUser(user) {
      getUser(this.user.access_token, user.id)
          .then(res => {
            // console.log('user res', res)
            this.inputs = {
              id: res.id,
              roles: {
                admin: res.roles.find(item => item.type === 'ADMIN') ? true : false,
                content: res.roles.find(item => item.type === 'CONTENT') ? true : false,
                sales: res.roles.find(item => item.type === 'SALES') ? true : false,
                accountant: res.roles.find(item => item.type === 'ACCOUNTANT') ? true : false
              },
              email: res.email,
              login: res.login,
              name: res.firstName,
              surname: res.lastName,
              password: '',
              country: {
                code: res.countryCode || '(+7)',
                data: this.dataSelects.countries.find(item => item.code === res.countryCode) ? this.dataSelects.countries.find(item => item.code === res.countryCode).data : 'ru'
              },
              number: res.contacts.PHONE.replace(/-/ig, ''),
              telegram: {
                active: res.contacts.TELEGRAM || false,
                login: res.contacts.TELEGRAM,
                ID: res.contacts.TELEGRAM_ID || ''
              },
              whatsapp: {
                active: res.contacts.WHATSAPP || false
              },
              photo: res.photo,
              signPhoto: res.signPhoto,
              mfaEnabled: res.mfaEnabled,
            }
            if (res.photo) {
              this.uploaded = true
            } else {
              this.uploaded = false
            }
            if (res.signPhoto) {
              this.uploadedSign = true
            } else {
              this.uploadedSign = false
            }
          })
      this.titleSection = 'Edit Manager'
      this.cancelBtn = 'Delete Manager'
      this.visibleInputs = true
      this.isEdit = true
      //set inputs
    },
    genPass() {
      this.inputs.password = generator.generate({
        length: 10,
      })
    },
    updateUserHandler() {
      // console.log(1)
      if (!this.checkError()) {
        // console.log(2)
        // if (this.inputs.number) {
        //   const code = this.inputs.country.code.replace('(', '').replace(')', '')
        //   this.inputs.number = code + this.inputs.number
        // }
        updateUser(this.user.access_token, this.inputs)
            .then(res => {
              this.managers = this.managers.map(item => {
                if (item.id === this.inputs.id) {
                  return {
                    email: this.inputs.email,
                    firstName: this.inputs.name,
                    id: this.inputs.id,
                    lastName: this.inputs.surname,
                    login: this.inputs.login,
                    photo: this.inputs.photo,
                    signPhoto: null

                  }
                } else {
                  return item
                }
              })
              this.$emit('confirmed')
              this.cancelInputs()
              this.isEditFlag = false
            })
      }
    },
    createUserHandler() {
      if (!this.checkError()) {
        // if (this.inputs.number) {
        //   const code = this.inputs.country.code.replace('(', '').replace(')', '')
        //   this.inputs.number = code + this.inputs.number
        // }
        createUser(this.user.access_token, this.inputs)
            .then(res => {
              this.managers = this.managers.concat(res)
              this.cancelInputs()
              this.$emit('confirmed')
              this.isEditFlag = false
            })
            .catch(error => {
              this.error.email = true
              this.error.login = true
            })
      }
    },
    deleteUserHandler() {
      deleteUser(this.user.access_token, this.inputs.id)
          .then(res => {
            this.managers = this.managers.filter(item => !(item.id === this.inputs.id))
            this.cancelInputs()
            this.toDelete = null
            this.$emit('confirmed')
          })
    },
    configureMfa() {
      postConfigureMfa(this.inputs.id, this.inputs.mfaEnabled)
          .then(response => {
            if (response.data.qrCode) {
              this.mfa.popup = true;
              this.mfa.qrCodeSrc = response.data.qrCode;
            }
            getUsers(this.user.access_token)
                .then(res => {
                  this.managers = res
                })
          });
    },
    removeAvatar() {
      this.inputs.photo = null
      this.uploaded = false
    },
    removeAvatarSign() {
      this.inputs.signPhoto = null
      this.uploadedSign = false
    }
  },
  mounted() {
    getUsers(this.user.access_token)
        .then(res => {
          this.isLoad = true
          this.managers = res
        })
    this.dataSelects.countries = countries.map((item, index) => index === 0 ? {...item, active: true} : {
      ...item,
      active: true
    }).map(item => ({
      ...item,
      data: item.data.toLowerCase(),
      name: item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase()
    })).filter(item => item.code)
    window.addEventListener('click', event => {
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          role: false,
          country: false,
          lang: false
        }
      }
      if (!event.target.closest('.delete-manager-popup') && !event.target.closest('.btn')) {
        this.toDelete = null
      }
    })
  },
  watch: {
    isEdit() {
      this.error = {
        role: false,
        email: false,
        login: false,
        password: false,
        name: false,
        surname: false,
        number: false,
        telegram: false,
        telegramID: false
      }
    },
    uploadedFile() {
      if (this.uploadedFile) {
        if (this.isSign) {
          this.inputs.signPhoto = this.uploadedFile
          this.uploadedSign = true
        } else {
          this.inputs.photo = this.uploadedFile
          this.uploaded = true
        }

      }
    }
  }
}
</script>
<style lang="scss" scoped>
.managers-edit-mfa {
  &__container {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 14px;
    margin: 1rem 0;
  }

  &__label {
    font-weight: 500;
    margin-right: 11px;
  }

  &__status {
    margin-left: 11px;
  }

  &__title {
    font-size: 17px;
    line-height: 20px;
    margin: 2rem 0 1rem;
    font-weight: 500;
    text-align: center;
  }

  &__code {
    display: flex;
    justify-content: center;
    padding: 2rem;
  }

  &__code-image {
    border-radius: 9px;
    border: 10px solid #FDFDFD;
    outline: 1px solid #EBEBEB;
  }

  &--poput {
    max-width: 450px;
    width: 100%;
  }
}
</style>
